import { render, staticRenderFns } from "./ZDeliveryCreationModal.vue?vue&type=template&id=050e5b41&scoped=true&"
import script from "./ZDeliveryCreationModal.vue?vue&type=script&lang=js&"
export * from "./ZDeliveryCreationModal.vue?vue&type=script&lang=js&"
import style0 from "./ZDeliveryCreationModal.vue?vue&type=style&index=0&id=050e5b41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e5b41",
  null
  
)

export default component.exports